/**
 * Format Press Release data for copying as Markdown
 */
export const formatPressReleaseCopy = (data: any): string => {
  if (!data || !data.headline) {
    return 'No press release content available';
  }

  const sections: string[] = [];

  // Headline
  sections.push(`# ${data.headline.toUpperCase()}`);
  sections.push('');

  // Subheadline (optional)
  if (data.subheadline) {
    sections.push(`## ${data.subheadline}`);
    sections.push('');
  }

  // Dateline
  if (data.dateline) {
    sections.push(`**${data.dateline}**`);
    sections.push('');
  }

  // Lead Paragraph
  if (data.lead_paragraph) {
    sections.push(data.lead_paragraph);
    sections.push('');
  }

  // Body Paragraphs
  if (data.body_paragraphs) {
    sections.push(data.body_paragraphs);
    sections.push('');
  }

  // Boilerplate
  if (data.boilerplate) {
    sections.push('---');
    sections.push('');
    sections.push(data.boilerplate);
    sections.push('');
  }

  // Media Contact
  if (data.media_contact) {
    sections.push('---');
    sections.push('');
    sections.push('**Media Contact:**');
    sections.push(data.media_contact.name);
    sections.push(data.media_contact.title);
    sections.push(data.media_contact.email);
    sections.push(data.media_contact.phone);
  }

  return sections.join('\n');
};
